// eslint-disable-next-line
export default {
   'titles.partners': 'Socios',
   'titles.programs': 'Programas',
   'titles.operations': 'Operaciones',
   'titles.dashboard': 'Dashboard',
   'titles.settings': 'Configuración',
   'titles.toggleMenu': 'Show or hide menu',
   'titles.collapseMenu': 'Collapse menu',
   'titles.expandMenu': 'Expand menu',
}
